'use client';

import { useT } from '@/components/i18n-provider';
import { useSystemNoticeTop } from '@/components/system-notice-position';
import { useConnectionStatus } from '@/lib/hooks/use-connection-status';
import { cn } from '@/lib/utils';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
  const { online } = useConnectionStatus();
  const t = useT();
  // The same place as the update pill: in the workspace, inside the title
  // bar's band and never over the app (components/system-notice-position.ts).
  const noticeTop = useSystemNoticeTop();
  if (online) return null;

  return (
    <div
      role="status"
      data-testid="offline-banner"
      className={cn('fixed left-1/2 -translate-x-1/2 z-[200] pointer-events-none', noticeTop)}
    >
      {/* 32 px tall (20 px line, 6 px above and below), so at 8 px from the
          top it ends at 40: inside a window's 40 px title bar and the 44 px
          app bar alike. */}
      <div className="flex items-center gap-2 rounded-full bg-red-600/70 text-white text-sm font-medium pl-3 pr-3.5 py-1.5 shadow-lg backdrop-blur-sm">
        <WifiOff className="h-4 w-4" />
        <span>{t('messages.offline')}</span>
      </div>
    </div>
  );
}
